var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegretBannerLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230,
    height: 151,
    viewBox: "0 0 97 86",
    fill: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.3222 -3.01701C85.5158 -5.44394 81.6202 -9.72104 74.0408 3.40335C69.5941 11.1032 73.6455 47.6512 53.9791 60.5116C34.3127 73.3721 4.16931 44.5914 -19.0907 61.5948C-43.571 79.4903 -7.82931 100.806 -32.7443 118.219C-52.6763 132.15 -85.8498 138.986 -88.292 132.737",
    stroke: "url(#paint0_linear_regret_left)",
    strokeWidth: 22
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_regret_left",
    x1: 70.0411,
    y1: 13.7761,
    x2: -84.5747,
    y2: 122.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0192308,
    stopColor: "#7CC66E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442308,
    stopColor: "#299C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879808,
    stopColor: "#7CC66E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegretBannerLeft);
export default __webpack_public_path__ + "static/media/RegretBannerLeft.811493fe34eb23f7e1a41f83f0777fd1.svg";
export { ForwardRef as ReactComponent };